module.exports = __webpack_public_path__ + "media/images/generic-error-image-7eff102dbf97802857b40130eba18baf.svg";